export default __webpack_public_path__ + "img/most.2fc9a038.svg";